import { useState, useEffect, useRef } from "react";
import GetIcon from "../../../../utils/Icon";
import EditItemModal from "./EditItemModal";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import ConfigureColumns from "./ConfigureColumns";
import Pagination from "../../../../Components/Pagination";

const Table = ({ list_data, row, fulldata, save }) => {
  console.log(row, "row-full");
  const getRowColor = (currentcolurraw) => {
    console.log(currentcolurraw, "row-new");
    const itemRows = row.Rows.filter(r => r.item_code === currentcolurraw.item_code);
    const totalScanQty = itemRows.reduce((sum, r) => sum + Number(r.scan_qty), 0);
    const tottalqty = itemRows.reduce((sum, r) => sum + Number(r.qty), 0);

    if (totalScanQty === 0) return 'not-distributed';
    if (totalScanQty === tottalqty) return 'fully-distributed';
    if (totalScanQty >= row.qty) return 'fully-distributed';
    return 'partially-distributed';
  };

  const tableRef = useRef(null);
  const inputRefs = useRef([]); // Refs for scan_qty inputs
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showError, setShowError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [columeConfModal, setcolumeConfModal] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const [visibleColumns, setVisibleColumns] = useState([
    { name: "S.No", selected: true, key: "sno", width: "5%" },
    { name: "Item Code", selected: true, key: "item_code", width: "17%" },
    { name: "Item Name", selected: true, key: "item_name", width: "25%" },
    { name: "Qty", selected: true, key: "qty", width: "5%" },
    { name: "Scan Qty", selected: true, key: "scan_qty", width: "4%" },
    { name: "UOM", selected: false, key: "uom", width: "7%" },
    { name: "Rate", selected: false, key: "rate", width: "10%" },
    { name: "Amount", selected: false, key: "amount", width: "10%" },
    { name: "Reject Qty", selected: false, key: "rejected_qty", width: "80px" },
    { name: "Barcode", selected: false, key: "barcode", width: "80px" },
    { name: "Manufacturing Date", selected: false, key: "manufacturing_date", width: "80px" },
    { name: "Expiry Date", selected: false, key: "expiry_date", width: "80px" },
    { name: "Serial No.", selected: false, key: "serial_numbers", width: "70px" },
    { name: "Batch No.", selected: false, key: "batch_no", width: "70px" },
    { name: "Box Id", selected: false, key: "parent", width: "19%" },
    { name: "Settings", selected: true, key: "settings", width: "4%" },
  ]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row.Rows.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    row.setRows(list_data);
  }, [list_data]);

  // Update input refs when rows change
  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, currentRows.length);
  }, [currentRows]);

  // Keyboard navigation handler
  const handleKeyDown = (e, rowIndex, field) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    
    if (field === 'scan_qty') {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextRowIndex = rowIndex + 1;
        if (nextRowIndex < currentRows.length) {
          const nextInput = inputRefs.current[nextRowIndex];
          if (nextInput) {
            nextInput.focus();
            nextInput.select();
          }
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevRowIndex = rowIndex - 1;
        if (prevRowIndex >= 0) {
          const prevInput = inputRefs.current[prevRowIndex];
          if (prevInput) {
            prevInput.focus();
            prevInput.select();
          }
        }
      }
    }
  };

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, [visibleColumns]);

  const openEditModal = (item, index) => {
    const filterdata = fulldata.message.items.filter((realitem) => realitem.item_code == item.item_code);
    setfull_Item_Detail(filterdata[0]);
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index);
    setShowEditModal(true);
  };

  const handleItemChange = (updatedItem) => {
    setCurrentItem(updatedItem);
  };

  const saveEdit = () => {
    const updatedRows = [...row.Rows];
    updatedRows[currentIndex] = currentItem;
    row.setRows(updatedRows);
    setShowEditModal(false);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...row.Rows];
    const totalQty = parseInt(updatedRows[indexOfFirstRow + index].qty) || 0;
    const newValue = parseInt(value) || 0;

    if (["accepted_qty", "rejected_qty", "scan_qty"].includes(field)) {
      if (newValue > totalQty) {
        setError(`${field.replace("_", " ")} cannot be greater than total quantity (${totalQty})`);
        setShowError(true);
        return;
      }
    }

    updatedRows[indexOfFirstRow + index][field] = value;
    row.setRows(updatedRows);
  };

  const handleSaveColumns = (columns) => {
    setVisibleColumns(columns);
  };

  const renderTableHeader = () => {
    return visibleColumns
      .filter(column => column.selected)
      .map((column, index) => {
        if (column.key === "settings") {
          return (
            <th key={index} onClick={() => setcolumeConfModal(true)} style={{ width: column.width, minWidth: column.width }}>
              <GetIcon iconName="IoSettingsOutline" size={13} />
            </th>
          );
        }
        return <th key={index} style={{  width: column.width, minWidth: column.width }}>
          {column.name}</th>;
      });
  };


  const renderTableRow = (rowData, rowIndex) => {
    const globalIndex = indexOfFirstRow + rowIndex;
    return visibleColumns
      .filter(column => column.selected)
      .map((column, colIndex) => {
        const key = column.key;

        if (key === "sno") {
          return (
            <td key={colIndex} className="p-0" >
              <p className="mb-0" >
                {globalIndex + 1}
              </p>
            </td>
          );
        }
        if (key === "settings") {
          return (
            <td key={colIndex} className="p-0" >
              <span onClick={() => openEditModal(rowData, rowIndex)} >
                <GetIcon iconName="MdOutlineEdit" size={15} />
              </span>
            </td>
          );
        }

        if (["accepted_qty", "rejected_qty", "expiry_date", "manufacturing_date", 'scan_qty'].includes(key)) {
          return (
            <td key={colIndex} className="p-0 d-flex justify-content-center" style={{ border: focusedCell.rowIndex === globalIndex && focusedCell.field === key ? '0.3px solid #270b79' : '' }}>
              <input
                ref={el => inputRefs.current[rowIndex] = el} // Add ref for keyboard navigation
                type={key.includes("date") ? "date" : "text"}
                className="form-control noborder"
                onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: key })}
                onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                onKeyDown={(e) => handleKeyDown(e, rowIndex, key)} // Add keyboard handler
                style={{ height: '30px',textAlign: 'center', fontSize: '0.8rem', background: 'transparent', width: key == "accepted_qty" ? '44%' : '' }}
                value={rowData[key]}
                onChange={(e) => handleInputChange(rowIndex, key, e.target.value)}
              />
            </td>
          );
        }

        return <td key={colIndex} className="p-0" >
          <p className="mb-0" >
            {key == "amount" || key == "rate" ? `₹${rowData[key]}` : rowData[key]}
          </p>
        </td>;
      });
  };

  return (
    <>
      <table className="table table-bordered" ref={tableRef} style={{borderCollapse  :'separate' ,borderSpacing :'0px'}} >
        <thead className="tableHead1" style={{ height: '30px' }}>
          <tr style={{ height: '30px' }}>
            {renderTableHeader()}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((crrow, index) => (
            <tr style={{ height: '30px',verticalAlign : 'middle' }} className={` ${getRowColor(crrow)} ${crrow.item_code == row?.selectedItem?.item_code ? 'blinkbackground' : ''}`} key={index}>
              {renderTableRow(crrow, index)}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center  centerpagination">
        <div>
          {/* <p style={{ textDecoration: "none" }} className="createbtn m-0">
            <span className="iconbox" style={{ padding: '0px 1px' }}>
              <GetIcon iconName="MdOutlineFileDownload" size={13} />
            </span>
            Download
          </p> */}
        </div>

        {row.Rows.length > 10 ? <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={rowsPerPage}
          totalrecords={row.Rows.length}
          currentPage={currentPage}
        /> : ''}

        {row.Rows.length > 10 ? <div>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79', position: 'relative', top: '-6px' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, row.Rows.length)} of {row.Rows.length} entries
          </span>
        </div> : ''}
      </div>

      <ConfigureColumns
        show={columeConfModal}
        onClose={() => setcolumeConfModal(false)}
        onSave={handleSaveColumns}
        initialFields={visibleColumns}
      />

      <EditItemModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        full_Item_Detail={full_Item_Detail}
        itemData={currentItem}
        onChange={handleItemChange}
        onSave={saveEdit}
      />

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default Table;